<template>
  <MyModal
    title="电量计算"
    height="600px"
    width="450px"
    v-if="isShow"
    @closeClick="handleCloseModalClick"
  >
    <div class="power-content">
      <div class="core">
        <div class="tab">
          <div
            :class="[
              'tab-item',
              {
                'is-active': item.active
              }
            ]"
            v-for="(item, index) in tabList"
            :key="index"
            @click="handleTabClick(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <template v-if="activeName === '全场'">
        <div class="deploy-content">
          <div class="row">
            <div class="row-item">
              <div class="row-item-core">
                <div class="key">尾流损失</div>
                <div class="value">
                  <StandInput v-model="flowLoss" onlyNumber></StandInput>
                </div>
                <el-tag>参考:0.00-0.10</el-tag>
              </div>
            </div>
            <div class="row-item">
              <div class="row-item-core">
                <div class="key">综合折减</div>
                <div class="value">
                  <StandInput v-model="synthesizeLoss" onlyNumber></StandInput>
                </div>
                <el-tag>参考:0.00-0.10</el-tag>
              </div>
            </div>
          </div>
        </div>
        <div class="calc-area">
          <ct-button type="primary" :btnClick="handleCalc">
            开始计算
          </ct-button>
        </div>
        <div v-if="!noCalcData" class="deploy-content">
          <div
            class="params-item"
            v-for="(item, index) in eneryParamsList"
            :key="index"
          >
            <div class="key">{{ item.name }}</div>
            <div class="value">
              <el-tag>{{ item.value }}</el-tag>
            </div>
            <div class="unit">{{ item.unit }}</div>
          </div>
        </div>

        <div v-if="!!chartOption" class="chart-content">
          <Chart :option="chartOption"></Chart>
        </div>
      </template>
      <template v-else>
        <div class="deploy-content" v-if="!noData">
          <div
            class="params-item"
            v-for="(item, index) in singleEneryParamsList"
            :key="index"
          >
            <div class="key">{{ item.name }}</div>
            <div class="value">
              <el-tag>{{ item.value }}</el-tag>
            </div>
            <div v-if="!!item.unit" class="unit">{{ item.unit }}</div>
          </div>
        </div>
        <div class="deploy-content" v-else>
          点击地图上的风机查看详情
        </div>

        <div v-if="!!singleChartOption" class="chart-content">
          <Chart :option="singleChartOption"></Chart>
        </div>
      </template>
    </div>
  </MyModal>
</template>

<script>
import MyModal from '../modal';
import StandInput from '../stand-input';
import Chart from './chart';
export default {
  components: {
    MyModal,
    StandInput,
    Chart
  },
  computed: {
    activeName() {
      return this.tabList.find(i => i.active).name;
    },
    noData() {
      return this.singleEneryParamsList.every(i => !i.value);
    },
    noCalcData() {
      return this.eneryParamsList.every(i => !i.value);
    }
  },
  data() {
    return {
      isShow: true,
      chartOption: null,
      singleChartOption: null,
      tabList: [
        {
          name: '全场',
          active: true
        },
        {
          name: '单风机',
          active: false
        }
      ],
      eneryParamsList: [
        {
          name: '理论发电量',
          key: 'annualEnergy',
          unit: 'MWh',
          value: ''
        },
        {
          name: '利用小时数',
          key: 'fullLoadHour',
          unit: 'h',
          value: ''
        },
        {
          name: '全场平均风速',
          key: 'wspd',
          unit: 'm/s',
          value: ''
        }
      ],
      singleEneryParamsList: [
        {
          name: '经度',
          key: 'lon',
          unit: '',
          value: ''
        },
        {
          name: '纬度',
          key: 'lat',
          unit: '',
          value: ''
        },
        {
          name: '高程',
          key: 'altitude',
          unit: 'm',
          value: ''
        },
        {
          name: '尾流损失',
          key: 'flowLoss',
          unit: '',
          value: ''
        },
        {
          name: '综合折减',
          key: 'synthesizeLoss',
          unit: '',
          value: ''
        },
        {
          name: '理论发电量',
          key: 'annualEnergy',
          unit: 'MWh',
          value: ''
        },
        {
          name: '利用小时数',
          key: 'fullLoadHour',
          unit: 'h',
          value: ''
        },
        {
          name: '平均风速',
          key: 'wspd',
          unit: 'm/s',
          value: ''
        },
        {
          name: 'A',
          key: 'weibullA',
          unit: '',
          value: ''
        },
        {
          name: 'K',
          key: 'weibullK',
          unit: '',
          value: ''
        }
      ],
      flowLoss: '',
      synthesizeLoss: '',
      windfarmEnergyInfo: ''
    };
  },
  created() {
    this.$bus.$on('checkPowerInPower', this.checkSingleTurPower);
    this.queryAllPower();
  },
  beforeDestroy() {
    this.$bus.$off('checkPowerInPower', this.checkSingleTurPower);

    this.$store.commit('WindFarm/UPDATE_TUILIST', {
      activeId: -1
    });
  },
  methods: {
    handleCloseModalClick() {
      this.$bus.$emit('farmClick', 4);
    },
    handleCalc() {
      this.$postForm('/windfarm/windfarm/computeStationEnergy', {
        data: {
          flowLoss: this.flowLoss,
          synthesizeLoss: this.synthesizeLoss,
          windfarmId: this.$route.query.windfarmId
        },
        showError: true,
        showLoading: true,
        showSuccess: true
      }).then(() => {
        this.queryAllPower();
      });
    },
    checkSingleTurPower(data) {
      if (this.activeName === '单风机') {
        this.$store.commit('WindFarm/UPDATE_TUILIST', {
          activeId: data.turbineId,
          force: true
        });

        this.$fetch('/windfarm/windfarm/getTurbineEnergy', {
          params: {
            turbineId: data.turbineId,
            windfarmId: this.$route.query.windfarmId
          },
          showError: true
        }).then(res => {
          const { data } = res;
          const { turbineEnergyInfo = [], turbinePowercurve = [] } = data;

          const itemInfo = turbineEnergyInfo[0];

          this.singleEneryParamsList.forEach(item => {
            item.value = itemInfo[item.key];
          });

          this.singleChartOption = this.getSingleChartOption(
            turbinePowercurve,
            itemInfo.turbineType
          );
        });
      }
    },

    getSingleChartOption(turbinePowercurve, turbineType) {
      const data = turbinePowercurve.map(i => [i.wspd, i.power]);

      return {
        legend: {
          show: true,
          data: [turbineType],
          textStyle: {
            color: '#000'
          }
        },
        tooltip: {
          show: true,
          formatter: params => {
            const { data = [] } = params;
            return `风速：${data[0]}m/s </br> 风功率：${data[1]}W/㎡ `;
          }
        },
        grid: {
          right: '80',
          left: '50'
        },
        textStyle: {
          color: '#000'
        },
        xAxis: {
          nameLocation: 'end',
          scale: true,
          boundaryGap: false,
          type: 'category',
          // max: 12,
          name: '风速(m/s)',
          axisTick: {
            show: true
          },
          axisLine: {
            lineStyle: {
              color: '#000'
            }
          }
        },
        yAxis: {
          splitNumber: 5,
          axisLine: {
            lineStyle: {
              color: '#000'
            }
          },
          name: '风功率(W/㎡)',
          type: 'value'
        },
        series: [
          {
            name: turbineType,
            data: data,
            type: 'line'
          }
        ]
      };
    },

    getChartOption(curveList = {}) {
      if (!Object.keys(curveList).length) return null;

      const arr = Object.keys(curveList).reduce((acc, cur) => {
        acc.push({
          name: cur,
          data: curveList[cur].map(i => [i.wspd, i.power])
        });
        return acc;
      }, []);

      return {
        grid: {
          right: '150',
          left: '50'
        },
        tooltip: {
          show: true,
          formatter: params => {
            const { data = [] } = params;
            return `风速：${data[0]}m/s </br> 风功率：${data[1]}W/㎡ `;
          }
        },
        legend: {
          show: true,
          data: arr.map(i => i.name),
          textStyle: {
            color: '#000'
          },
          right: 0,
          orient: 'vertical'
        },
        textStyle: {
          color: '#000'
        },
        xAxis: {
          nameLocation: 'end',
          scale: true,
          boundaryGap: false,
          type: 'category',
          // max: 12,
          name: '风速(m/s)',
          axisTick: {
            show: true
          },
          axisLine: {
            lineStyle: {
              color: '#000'
            }
          }
        },
        yAxis: {
          splitNumber: 5,
          axisLine: {
            lineStyle: {
              color: '#000'
            }
          },
          name: '风功率(W/㎡)',
          type: 'value'
        },
        series: arr.map(i => {
          return {
            name: i.name,
            data: i.data,
            type: 'line'
          };
        })
      };
    },

    queryAllPower() {
      this.$fetch('/windfarm/windfarm/getWindfarmEnergy', {
        params: {
          windfarmId: this.$route.query.windfarmId
        },
        showError: true
      }).then(res => {
        const { data } = res;
        const {
          flowLoss,
          synthesizeLoss,
          windfarmEnergyInfo = [],
          curveList = {}
        } = data;
        this.flowLoss = flowLoss;
        this.synthesizeLoss = synthesizeLoss;
        const eneryInfo = windfarmEnergyInfo[0];

        this.chartOption = this.getChartOption(curveList);

        if (eneryInfo) {
          this.eneryParamsList.forEach(item => {
            item.value = eneryInfo[item.key];
          });
        }
      });
    },
    handleTabClick(item) {
      this.tabList.forEach(i => {
        if (i !== item) {
          i.active = false;
        } else {
          i.active = true;
        }
      });

      this.singleChartOption = null;
    }
  }
};
</script>

<style lang="less" scoped>
.power-content {
  padding: 5px 10px 20px 10px;

  .core {
    // background-color: #fff;
    border-radius: 7px;
    // padding: 10px;
    .tab {
      user-select: none;
      display: flex;
      align-items: center;
      .tab-item {
        height: 28px;
        width: 85px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border: 2px solid #0877be;
        cursor: pointer;
        &:first-child {
          border-radius: 5px 0px 0px 5px;
        }
        &:last-child {
          border-radius: 0px 5px 5px 0px;
        }
        &.is-active {
          background-color: #0877be;
          color: #fff;
        }
      }
    }
  }

  .calc-area {
    text-align: right;
    margin-top: 10px;
  }
  .deploy-content {
    background-color: #fff;
    margin-top: 10px;
    border-radius: 7px;
    padding: 20px;
    .params-item {
      display: flex;
      &:not(:first-child) {
        margin-top: 10px;
      }
      align-items: center;
      & > div {
        margin-right: 5px;
      }
      .key {
        width: 100px;
      }
      .value {
        width: 100px;
      }
      .unit {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .row {
    .row-item {
      margin-bottom: 10px;
      .row-item-core {
        display: flex;
        align-items: center;
        .key {
          margin-right: 5px;
          width: 60px;
          font-weight: 500;
        }
        .value {
          width: 150px;
          margin-right: 10px;
        }
      }
    }
  }

  .chart-content {
    border-radius: 7px;
    padding: 5px;
    background-color: #fff;
    margin-top: 10px;
    height: 300px;
    width: 100%;
  }
}
</style>
